<template>
    <div>
        <div class="g-hd" >
            <ul class="hdList">
                <li>
                    <div class="lf">
                        <div class="tt">本月绩效累计(元)</div>
                        <div class="num">{{data.monthTotal.totalFee | moneyP}}</div>
                    </div>
                    <div class="rg">
                        <div class="tt">昨日绩效(元)</div>
                        <div class="num mark">{{data.total.totalFee | moneyP}}</div>
                    </div>
                </li>
                <li>
                    <section class="itemBox" v-show="isItem">
                        <div class="item">
                            <div class="tt">诊查费</div>
                            <div class="f-dfsb">
                                <span class="lf">{{data.monthTotal.examinationFee | moneyP}}</span>
                                <span class="rg">{{data.total.examinationFee | moneyP}}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">收住院</div>
                            <div class="f-dfsb">
                                <span class="lf">{{data.monthTotal.inpatientNumFee | moneyP }}</span>
                                <span class="rg">{{data.total.inpatientNumFee | moneyP }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">检查开单</div>
                            <div class="f-dfsb">
                                <span class="lf">{{data.monthTotal.checkorderFee | moneyP }}</span>
                                <span class="rg">{{data.total.checkorderFee | moneyP }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">手术费</div>
                            <div class="f-dfsb">
                                <span class="lf">{{data.monthTotal.operationFee | moneyP }}</span>
                                <span class="rg">{{data.total.operationFee | moneyP }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">检查相关</div>
                            <div class="f-dfsb">
                                <span class="lf">{{data.monthTotal.checkrelatedFee | moneyP }}</span>
                                <span class="rg">{{data.total.checkrelatedFee | moneyP }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="tt">单项奖励</div>
                            <div class="f-dfsb">
                                <span class="lf">{{data.monthTotal.singleFee | moneyP }}</span>
                                <span class="rg">{{data.total.singleFee | moneyP }}</span>
                            </div>
                        </div>
                    </section>
                </li>
                <li @click="isShowItem">
                    <img v-if="isItem" class="arr2" src="../assets/jxwx/arr.png" alt="">
                    <img v-else src="../assets/jxwx/arr.png" alt="">
                </li>
            </ul>
        </div>
        <div class="u-title">
            <img src="../assets/jxwx/line.png" alt=""> 近{{timeActive | timeF}}医院绩效趋势
        </div>
        <section class="f-bcf f-mgb">
            <ve-line :extend="chartExtend" :data="chartData" height="175px" :legend-visible="false"></ve-line>
            <ul class="timeList">
                <li v-for="(item,index) in timeList" :key="item.id" :class="{active:timeActive == index}" @click="timeChoose(index)">{{item.time}}</li>
            </ul>
        </section>
        <div class="u-title">
            <img src="../assets/jxwx/line.png" alt=""> 本月科室主诊组绩效Top5
        </div>
        <div class="box">
            <div class="progressBox" v-for="item in data.sortDetail.slice(0,5)" :key="item.id" @click="toDirector(item)">
                <span class="name">
                    <span>{{item.department_name | depName}}</span>
                    <span>主诊组</span>
                </span>
                <div class="u-progress">
                    <div class="progress_bar progress_bar_02" :style="{width: item.percent}">
                    </div>
                </div>
                <span class="num">{{item.totalFee | moneyP}}</span>
                <img class="arrIcon" src="../assets/jxwx/arr_03.png" alt="">
            </div>
            <div class="allSort" @click="toAllSort()">全部排名</div>
        </div>
        <div class="u-detailsRecord" @click="toDetail()">
            查看绩效记录
            <img src="../assets/jxwx/arr_03.png" alt="">
        </div>
        <div class="u-title">
            <img src="../assets/jxwx/line.png" alt=""> 科室主诊组当前医保均次占比
        </div>
        <div class="u-card cardBox" v-for="item in countData" :key="item.id" @click="toDepDetails(item)">
            <div class="hd">
                <div class="tt">
                    <img class="icon" src="../assets/jxwx/report/icon_04.png" alt="">
                    <span>{{item.departMentName}}</span>
                </div>
                <img class="arr" src="../assets/jxwx/arr_05.png" alt="">
            </div>
            <div class="bd">
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../assets/jxwx/report/point.png" alt=""> 门诊-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.townouthosprop <= 80,'progress_bar3':item.townouthosprop >= 100}" :style="{width: item.townouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次占比</span>
                        <span class="mark nm">{{item.townouthosprop}}%</span>
                    </div>
                </div>
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../assets/jxwx/report/point.png" alt=""> 门诊-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.resouthosprop <= 80,'progress_bar3':item.resouthosprop >= 100}" :style="{width: item.resouthosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次占比</span>
                        <span class="mark nm">{{item.resouthosprop}}%</span>
                    </div>
                </div>
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../assets/jxwx/report/point.png" alt=""> 住院-城镇
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.towninhosprop <= 80,'progress_bar3':item.towninhosprop >= 100}" :style="{width: item.towninhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次占比</span>
                        <span class="mark nm">{{item.towninhosprop}}%</span>
                    </div>
                </div>
                <div class="m-hos">
                    <header class="f-df">
                        <img src="../assets/jxwx/report/point.png" alt=""> 住院-居民
                    </header>
                    <div class="progress">
                        <div class="progress_bar" :class="{'progress_bar2':item.resinhosprop <= 80,'progress_bar3':item.resinhosprop >= 100}" :style="{width: item.resinhosprop + '%'}">
                        </div>
                    </div>
                    <div class="entry">
                        <span class="ctt">医保均次占比</span>
                        <span class="mark nm">{{item.resinhosprop}}%</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="allSort" @click="toAllDepartment()">全部科室</div>
    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getResult(this.time);
                    this.getDailyCountData(this.time);
                }
            }
        }
    },
    data() {
        return {
            arr: [],
            isItem: false,
            timeActive: 0,
            timeList: [
                {
                    time: "近1月"
                },
                // {
                //     time: "近3月"
                // },
                {
                    time: "近6月"
                },
                {
                    time: "近1年"
                }
            ],
            chartExtend: {
                grid: {
                    x: 20,
                    y: 20,
                    x2: 20,
                    y2: 5
                },
                series: {
                    symbol: "none",
                    lineStyle: {
                        normal: {
                            color: "#77E49D"
                        }
                    }
                },
                xAxis: {
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    }
                },
                yAxis: {
                    axisTick: {
                        //y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    },
                    splitLine: {
                        //网格线
                    }
                }
            },
            chartData: {
                columns: ["日期", "绩效"],
                rows: []
            },
            data: {},
            classData: [],
            monthdayList: [],
            sixMonthList: [],
            yearList: [],
            time: this.$route.query.today,
            countData: []
        };
    },
    filters: {
        depName: function(val) {
            if (val) {
                return val.substring(0, val.length - 3);
            }
        },
        timeF: function(val) {
            switch (val) {
                case 0:
                    return "1月";
                    break;
                case 1:
                    return "6月";
                    break;
                case 2:
                    return "1年";
                    break;
            }
        }
    },
    mounted() {
        //   this.getResult(this.time);
        //   this.getDailyCountData(this.time);
    },
    methods: {
        
        timeChoose(index) {
            this.timeActive = index;
            this.classData = [];
            this.lineData();
            console.log(this.classData);
        },
        lineData() {
            switch (this.timeActive) {
                case 0:
                    this.monthdayList.forEach(item => {
                        var i = {
                            日期: item.feedate,
                            绩效: item.totalFee
                        };
                        this.classData.push(i);
                    });
                    this.chartData.rows = this.classData;
                    break;
                case 1:
                    this.sixMonthList.forEach(item => {
                        var i = {
                            日期: item.month,
                            绩效: item.totalFee
                        };
                        this.classData.push(i);
                    });
                    this.chartData.rows = this.classData;
                    break;
                case 2:
                    this.yearList.forEach(item => {
                        var i = {
                            日期: item.month,
                            绩效: item.totalFee
                        };
                        this.classData.push(i);
                    });
                    this.chartData.rows = this.classData;
                    break;
            }
        },
        isShowItem() {
            this.isItem = !this.isItem;
        },
        getResult(time) {
            let params = {
                today: time
            };
            api.getResult(params).then(res => {
                this.data = res.result;
                this.monthdayList = this.data.JXRecord.JXRecordList.reverse();
                this.sixMonthList = this.data.sixMonthCurve.reverse();
                this.yearList = this.data.yearCurve.reverse();
                this.lineData();
            });
        },
        getDailyCountData(time) {
            let params = {
                date: time,
                depId:"",
                deptMentId:""
            };
            api.getDailyCountData(params).then(res => {
                this.countData = res.slice(0, 2);
            });
        },
        toDetail() {
            this.$router.replace({
                path: "/jxwx/details",
                query: {
                    name: "绩效记录",
                    title: "",
                    data: this.data.JXRecord
                }
            });
        },
        toAllSort() {
            this.$router.replace({
                path: "/jxwx/allSort",
                query: {
                    data: this.data.sortDetail,
                    time: this.time
                }
            });
        },
        toAllDepartment() {
            this.$router.replace({
                path: "/jxwx/allDepartment",
                query: {
                    time: this.time
                }
            });
        },
        toDepDetails(item) {
            this.$router.replace({
                path: "/jxwx/depDetails",
                query: {
                    data:item,
                    time: this.time
                }
            });
        },
        toDirector(item) {
            if (item.directorId) {
                this.$router.replace({
                    path: "/jxwx/director",
                    query: {
                        departmentId: item.department_id,
                        directorId: item.directorId,
                        today: this.time,
                        isback: true
                    }
                });
            } else {
                this.$toast.fail("该主诊组暂无主任");
            }
        }
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    padding-top: 2vw;
    background: #e5323b;
    .hdList {
        li {
            display: flex;
            justify-content: space-between;
            padding: 3vw 4vw 0 4vw;
            .lf {
                text-align: left;
            }
            .rg {
                text-align: right;
            }
            .tt {
                margin-bottom: 3vw;
            }
        }
        li:first-child {
            .tt {
                font-size: 13px;
                color: #ff9c9d;
            }
            .num {
                font-size: 30px;
                color: #fff;
            }
            .mark {
                color: #fccd33;
            }
        }
        li:nth-child(2) {
            padding: 0;
        }
        li:nth-child(3) {
            justify-content: center;
            align-items: center;
            height: 5.3vw;
            padding: 0;
            img {
                width: 2.5vw;
            }
            .arr2 {
                transform: rotate(180deg);
            }
        }
        .itemBox {
            display: flex;
            flex-wrap: wrap;
            padding-top: 3vw;
            .item {
                width: 50%;
                box-sizing: border-box;
                padding: 2vw 4vw;
                border-bottom: 1px solid#EF5E65;
                .tt {
                    margin-bottom: 2vw;
                    font-size: 13px;
                    color: #fff;
                    text-align: left;
                    color: #ff9c9d;
                }
                .lf {
                    font-size: 13px;
                    color: #ff9c9d;
                }
                .rg {
                    font-size: 13px;
                    color: #fccd33;
                }
            }
            .item:nth-child(1) {
                border-top: 1px solid#EF5E65;
            }
            .item:nth-child(2) {
                border-top: 1px solid#EF5E65;
            }
            .item:nth-child(odd) {
                border-right: 1px solid#EF5E65;
            }
        }
    }
}
.timeList {
    display: flex;
    background-color: #fafcff;
    height: 9.2vw;
    font-size: 13px;
    color: #a6a6a6;
    li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        border-top: 1px solid #dedede;
    }
    li.active {
        color: #2c2c2c;
        background-color: #fff;
        border-top: 1px solid #fff;
        border-right: 1px solid #dedede;
        border-left: 1px solid #dedede;
    }
    li:first-child.active {
        border-left: none;
    }
    .customizeBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 14.6vw;
        height: 6.4vw;
        line-height: 1;
        border: 1px solid #0897ea;
        border-radius: 6px;
        color: #0897ea;
        box-sizing: border-box;
    }
}
.box {
    background-color: #fff;
    margin-bottom: 2.6vw;
    padding: 0 4vw 4vw 4vw;
    .progressBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2vw 0;
        border-bottom: 1px solid #dedede;
        .u-progress {
            width: 43vw;
            margin: 0 4vw;
        }
        span {
            display: inline-block;
            font-size: 13px;
            box-sizing: border-box;
        }
        .name {
            width: 19vw;
            text-align: right;
            color: #a6a6a6;
            span {
                width: 100%;
            }
        }
        .num {
            width: 20vw;
        }
        .arrIcon {
            width: 2vw;
        }
    }
    .allSort {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 47.6vw;
        height: 8.5vw;
        margin: 4vw auto 0 auto;
        border: 1px solid #e5323b;
        border-radius: 6px;
        color: #e5323b;
    }
}

// .u-detailsRecord {
//     margin-bottom: 12vw;
// }

.u-card {
    margin: 2.6vw 4vw;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91C619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #F66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
    
}
.allSort {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 47.6vw;
        height: 8.5vw;
        margin: 4.5vw auto;
        border: 1px solid #e5323b;
        border-radius: 6px;
        color: #e5323b;
    }
</style>





// WEBPACK FOOTER //
// src/jxwx/dean.vue